<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filtrosreportecentroconsumos-component ref="filtersReport"></filtrosreportecentroconsumos-component>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-4 text-center">
                        <div v-if="loadingGetDataRG">
                            <img :src="'/theme/img/loads/pelota.gif'" alt="carga archivo" height="40">
                            <p>Preparando reporte, espere...</p>
                        </div>
                    </div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReportRG">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResultRG">
                        <div v-if="loadfileRG">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfileRG"  class="btn btn-success" type="button" @click="ExportFileRG"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Excel</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-danger" type="button" @click="DownloadFilePptx(false, 'capacitaciones')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Capacitaciones</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-danger" type="button" @click="DownloadFilePptx(false, 'supervisionCompetencia')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Supervisión Competencia</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-danger" type="button" @click="DownloadFilePptx(false, 'seguimientoCuenta')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Seguimiento Cuenta</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-danger" type="button" @click="DownloadFilePptx(false, 'supervisionMot')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Supervisión Moët</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-danger" type="button" @click="DownloadFilePptx(false, 'cartas')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Cartas</b></button>
                        <button v-if="!loadfileRG"  class="btn btn-info" type="button" @click="DownloadFilePptx(false, 'publicidad')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Publicidad</b></button>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-md-12" v-show="showResultRG">
                        <v-client-table :data="tableDataRG" :columns="columnsRG" :options="optionsRG" class="table-responsive" ref="tablePromociones">
                            <div slot="Tienda" slot-scope="props">
                                <span v-html="props.row.Tienda"></span>
                                <br>
                                <button class="btn btn-sm btn-primary" @click="DownloadFilePptx(props.row.Ruta,'capacitaciones')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i> Capacitaciones</button>
                                <button class="btn btn-sm btn-primary" @click="DownloadFilePptx(props.row.Ruta,'supervisionCompetencia')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i> Supervisión Competencia</button>
                                <button class="btn btn-sm btn-primary" @click="DownloadFilePptx(props.row.Ruta,'seguimientoCuenta')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i> Seguimiento Cuenta</button>
                                <button class="btn btn-sm btn-primary" @click="DownloadFilePptx(props.row.Ruta,'supervisionMot')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i> Supervisión Moët</button>
                                <button class="btn btn-sm btn-primary" @click="DownloadFilePptx(props.row.Ruta,'cartas')"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i> Cartas</button>
                            </div>
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaReporteGrafico",
    data(){
        return{
            loadfileRG:false,
            showResultRG:false,
            loadingGetDataRG: false,
            showDataRG: false,
            columnsRG: ['Ruta','Fecha','Semana','Area','Agencia','Tipo','Rol','Usuario','Estado','Ciudad','Canal','Cadena','Formato','Tienda'],
            tableDataRG: [],
            optionsRG: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Usuario','Tienda','Area','Formato','Canal','Cadena'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                    InventarioF: [
                        {
                            class:'bg-danger',
                            condition: row => row.InventarioF <= 0
                        }
                    ]
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                    Resurtido: 'Resurtido',
                    Ventas: 'Ventas',
                    Fotografico: 'Fotográfico',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Tienda: 'text-center',
                    Area: 'text-center',
                    Formato: 'text-center',
                    Canal: 'text-center',
                    Cadena: 'text-center',
                    Fecha: 'text-center',
                    Fotografico: 'text-center',
                    Ventas: 'text-center',
                    Inventarios: 'text-center',
                    Comentario: 'text-center',
                    Encuestas: 'text-center',
                    Faltantes: 'text-center',
                    Exhibiciones: 'text-center',
                    Anaquel: 'text-center',
                    Promociones: 'text-center',
                    Comentarios: 'text-center',
                    Resurtidos: 'text-center',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReportRG();
            }
        },
        getReportRG(){ let $this = this
            var filters = this.$refs.filtersReport.filters
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center')
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center')
            }else{
                this.loadingGetDataRG = true
                this.showDataRG = false
                this.showResultRG = false
                this.tableDataInventario = []
                axios.post('/api/ReporteGrafico/TablaCentrosConsumo',{data:filters})
                    .then(r => {
                            $this.loadingGetDataRG = false
                            $this.showDataRG = true
                            $this.tableDataRG = r.data.Data
                            $this.showResultRG = true
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center')
                        }
                    )
            }
        },
        ExportFileRG(){
            let $this = this
            this.loadfileRG = true
            var filters = this.$refs.filtersReport.filters
            axios({
                method: 'post',
                url: '/api/ReporteGrafico/exportLayoutToExcelCentrosConsumo',
                responseType: 'arraybuffer',
                data: { data: filters }
            }).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'ReporteGraficoMoet.xlsx'
                    link.click()
                    $this.loadfileRG=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfileRG=false;
                }
            );
        },
        DownloadFilePptx(ruta, reporte){
            let $this = this
            this.loadfileRG = true
            var filters = this.$refs.filtersReport.filters
            if(!ruta){
                ruta = this.tableDataRG.map(item => item.Ruta)
            }
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center')
            }
            else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center')
            }
            else{
                axios({
                    method: 'post',
                    url: '/api/ReporteGrafico/DownloadReporteCentroConsumo',
                    responseType: 'arraybuffer',
                    data: {
                        ruta,
                        reporte,
                        timeInit: filters.timeInit,
                        timeEnd: filters.timeEnd,
                    }}).then(r => {
                        let blob = new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'ReporteCentroConsumoMoet.pptx'
                        link.click()
                        $this.loadfileRG=false;
                    },
                    error => {
                        $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        $this.loadfileRG=false;
                    }
                );
            }
        },
    }
}
</script>

<style scoped>

</style>
